import React, { useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { Header } from "../Header";
import { AppointmentSidebar } from "../AppointmentSidebar";
import { ProgressBar } from "../ProgressBar";
import { captureException } from "@sentry/react";

export function BookingFlowLayout({ children }: React.PropsWithChildren) {

    const [search] = useSearchParams();

    useEffect(() => {
        if (search.has('fallback')) {
            captureException("Opened fallback", {
                level: "info",
                extra: {
                    fallback: search.get('fallback')
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className="flex flex-col min-h-dvh">
        <Header progressBar className="hidden lg:block" />
        <div className="flex-1 flex flex-col lg:flex-row">
            <aside className="lg:max-w-md w-full bg-gray-50 border-r border-gray-200 p-4 lg:p-8">
                <AppointmentSidebar />
            </aside>
            <ProgressBar className="block lg:hidden" />
            <main className="flex-1 lg:py-8 bg-white relative flex">
                <div className="max-w-lg mx-auto 2xl:mx-72 pt-5 flex flex-col flex-1">
                    <Outlet />
                    {children}
                </div>
            </main>
        </div>
    </div>
}